import React from "react";
import {connect} from "react-redux";
import queryString from "query-string";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Card, Col, Container, Modal, Row} from "react-bootstrap";
import {productoActions} from "../../../_actions";
import {ErrorMessage, history, LoadingBoton} from "../../../_helpers";
import {NavBarLateral} from "../../includes";
import authService from "../../../_services/cart/authService";
import userServiceTs from "../../../_services/cart/userService";
import http from '../../../_services/cart/http.service';
import alertService from "../../../_services/cart/alert.service";
import ReactSwitch from "react-switch";
import { Formik, Form, Field } from "formik";
import { userService } from "../../../_services";
import * as Yup from "yup";

class FormEditarMP extends React.Component {

    state = {
        showMp: false,
        grabando: false
    }


    componentDidMount() {

    }

    render() {

        const {usuario, show, handleCloseMp} = this.props;

        // Los secretos no llegan al navegador (ni al admin): vacio = no cambiar.
        let inic = {
            mercadoPagoWebhookKey: "",
            mercadoPagoPublicKey: usuario?.mercadoPagoPublicKey ?? "",
            mercadoPagoPrivateKey: "",
        };

        const validationSchema = Yup.object().shape({
            mercadoPagoPublicKey: Yup.string()
            .min(12, "Public key debe tener al menos 15 caracteres")
            .max(100, "Demasiado largo"),
             mercadoPagoPrivateKey: Yup.string()
            .min(12, "Private key debe tener al menos 15 caracteres")
            .max(100, "Demasiado largo"),
            mercadoPagoWebhookKey: Yup.string()
            .min(12, "WebHook key debe tener al menos 15 caracteres")
            .max(100, "Demasiado largo"),
        });


        return (
            <><Modal
                        show={show}
                        onHide={handleCloseMp}
                        backdrop="static"
                    >
                        <Modal.Header className="bg-cielo " closeButton>
                        <Modal.Title>
                            <i className="fas fa-paper-plane"></i> Editar credenciales MP
                        </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="th_uva">

                        <Formik
                            enableReinitialize={true}
                            initialValues={inic}
                            validationSchema={validationSchema}
                            onSubmit={(values) => {
                            this.setState({ grabando: true });
                            values.id = usuario.id;
                            userService.actualizarMPCredencialesAdmin(values).then(
                                (data) => {
                                    this.setState({ grabando: false });
                                    alertService.msg(
                                        "Credenciales Mercado Pago actualizadas exitosamente."
                                    );
                                    handleCloseMp();
                                },
                                (error) => {
                                    this.setState({ grabando: false });
                                    alertService.error(error);
                                }
                            );
                            }}
                        >
                            {({ errors, touched, values }) => (
                            <Form>

                                <div className="form-group">
                                    <label htmlFor="mercadoPagoPublicKey">
                                    Clave Publica
                                    </label>
                                    <Field name="mercadoPagoPublicKey" type={"text"}  className="input--outline" />
                                    <ErrorMessage name={`mercadoPagoPublicKey`} />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="mercadoPagoPrivateKey">
                                    Clave Privada
                                    </label>
                                    <Field name="mercadoPagoPrivateKey" type={"password"} autoComplete="off" className="input--outline"
                                           placeholder={usuario?.mercadoPagoPrivateKeyCargada ? "Ya está cargada. Dejala vacía para no cambiarla." : ""} />
                                    <ErrorMessage name={`mercadoPagoPrivateKey`} />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="mercadoPagoWebhookKey">
                                    Webhook key Privada
                                    </label>
                                    <Field name="mercadoPagoWebhookKey" type={"password"} autoComplete="off" className="input--outline"
                                           placeholder={usuario?.mercadoPagoWebhookKeyCargada ? "Ya está cargada. Dejala vacía para no cambiarla." : ""} />
                                    <ErrorMessage name={`mercadoPagoWebhookKey`} />
                                </div>

                                <div className="justify-content-center p-3 row border-top">

                                <button
                                    className="button"
                                    type="submit"
                                    data-type='primary'
                                    disabled={this.state.grabando}
                                >
                                    <i className="icon-floppy"></i> Grabar{" "}
                                    <LoadingBoton grabando={this.state.grabando} />
                                </button>
                                </div>
                            </Form>
                            )}
                        </Formik>
                        </Modal.Body>
                    </Modal>
            </>
        );
    }
}

function mapState(state) {
    const {} = state;
    return {};
}

const actionCreators = {};

const connectedFormEditarMP = connect(mapState, actionCreators)(FormEditarMP);
export {connectedFormEditarMP as FormEditarMP};
